module.exports = __webpack_public_path__ + "img/yishi30.2737e031.jpg";